import { render, staticRenderFns } from "./VideoColumn.vue?vue&type=template&id=6f3d799e&scoped=true"
import script from "./VideoColumn.vue?vue&type=script&lang=js"
export * from "./VideoColumn.vue?vue&type=script&lang=js"
import style0 from "./VideoColumn.vue?vue&type=style&index=0&id=6f3d799e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3d799e",
  null
  
)

export default component.exports